// extracted by mini-css-extract-plugin
export default {"colorDiv":"Defended_colorDiv__adjSJ"};